export class ServiceType {
    static CARWASH = 1;
    static TIRES = 2;
    static VALET = 3;
}

Object.freeze(ServiceType);